
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("hhs5g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $c949cf11b3dad355$var$_swiper = $c949cf11b3dad355$var$_interopRequireDefault((parcelRequire("htp1E")));

var $bTZx8 = parcelRequire("bTZx8");

var $c949cf11b3dad355$var$_scrollytellingVideoSlide = $c949cf11b3dad355$var$_interopRequireDefault((parcelRequire("364bU")));
function $c949cf11b3dad355$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $c949cf11b3dad355$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c949cf11b3dad355$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c949cf11b3dad355$var$_typeof(o);
}
function $c949cf11b3dad355$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c949cf11b3dad355$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c949cf11b3dad355$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c949cf11b3dad355$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c949cf11b3dad355$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c949cf11b3dad355$var$_defineProperty(e, r, t) {
    return (r = $c949cf11b3dad355$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $c949cf11b3dad355$var$_toPropertyKey(t) {
    var i = $c949cf11b3dad355$var$_toPrimitive(t, "string");
    return "symbol" == $c949cf11b3dad355$var$_typeof(i) ? i : i + "";
}
function $c949cf11b3dad355$var$_toPrimitive(t, r) {
    if ("object" != $c949cf11b3dad355$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c949cf11b3dad355$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
} // ====================================================================================
// scrollytelling.module.js
// ====================================================================================
var $c949cf11b3dad355$var$baseModules = [
    $bTZx8.Navigation,
    $bTZx8.Pagination,
    $bTZx8.A11y,
    $bTZx8.Keyboard,
    $bTZx8.Thumbs
];
var $c949cf11b3dad355$var$pages = document.querySelectorAll(".scrollytelling-page");
var $c949cf11b3dad355$var$nav = document.querySelector(".scrolly-nav-inner");
var $c949cf11b3dad355$var$navBar = document.querySelector(".scrolly-nav-bar");
var $c949cf11b3dad355$var$outerSlider = document.querySelector(".scrolly-pages");
var $c949cf11b3dad355$var$innerSliders = document.querySelectorAll(".scrolly-content");
var $c949cf11b3dad355$var$header = document.querySelector(".page-header");
var $c949cf11b3dad355$var$footer = document.querySelector(".page-footer");
var $c949cf11b3dad355$var$pagination = {
    headerHeight: 0,
    footerHeight: 0,
    complete: false,
    activePage: null,
    activeSliderId: null,
    progresses: {},
    items: {},
    list: []
};
var $c949cf11b3dad355$var$sliders = {
    outer: null,
    oList: {},
    iList: {}
};
var $c949cf11b3dad355$var$getParent = function getParent(el, selector) {
    var parent = el;
    while(!parent.classList.contains(selector))parent = parent.parentElement;
    return parent;
};
var $c949cf11b3dad355$var$fixTextPosition = function fixTextPosition(swiper) {
    if (swiper.slides.length < 1) return;
    var activeId = swiper.slides[swiper.activeIndex].id;
    var activeSlide = document.getElementById(activeId);
    var activeText = activeSlide.querySelector(".text");
    if (!activeText) return;
    var cssTop = parseFloat(activeText.dataset.top);
    activeText.style.top = cssTop + "%";
};
var $c949cf11b3dad355$var$fixTextPosition2 = function fixTextPosition2(id) {
    if (!id) return;
    var activeSlide = document.getElementById(id);
    var activeText = activeSlide.querySelector(".text");
    if (!activeText) return;
    var cssTop = parseFloat(activeText.dataset.top);
    activeText.style.top = cssTop + "%";
};
var $c949cf11b3dad355$var$updateProgressBar = function updateProgressBar() {
    var el = document.getElementById("b-".concat($c949cf11b3dad355$var$pagination.activePage));
    // if (!el) {
    //   el = document.getElementById(`b-${pagination.activeSliderId}`);
    // }
    if (!el) return;
    var bounds = el.getBoundingClientRect();
    // let factor = pagination.progresses[pagination.activeSliderId];
    var navBounds = $c949cf11b3dad355$var$nav.getBoundingClientRect();
    var progressWidth = bounds.width / 2;
    var progress = bounds.left - navBounds.left + progressWidth;
    if ($c949cf11b3dad355$var$pagination.complete) $c949cf11b3dad355$var$navBar.style.width = "100%";
    else $c949cf11b3dad355$var$navBar.style.width = "".concat(progress, "px");
};
var $c949cf11b3dad355$var$updateNavIndex = function updateNavIndex(swiper) {
    var index = swiper.activeIndex;
    var activeId = swiper.slides[swiper.activeIndex].id;
    var sliderId = null;
    // if (swiper.el.classList.contains("scrollytelling-page")) {
    //   sliderId = swiper.el.parentElement.id;
    //   pagination.progresses[sliderId] = swiper.progress;
    //   pagination.activeSliderId = sliderId;
    // } else if (swiper.el.classList.contains("scrolly-pages")) {
    //   pagination.activeSliderId = swiper.slides[swiper.activeIndex].id;
    // } else if (swiper.el.classList.contains("scrolly-content")) {
    //   sliderId = swiper.el.parentElement.id;
    //   pagination.activeSliderId = sliderId;
    //   pagination.progresses[sliderId] = swiper.progress;
    // }
    var button = $c949cf11b3dad355$var$nav.querySelector('button[data-index="'.concat(index, '"]'));
    if (button) {
        $c949cf11b3dad355$var$nav.querySelectorAll(".nav-button").forEach(function(btn) {
            btn.classList.remove("active");
            btn.classList.remove("before");
            btn.classList.remove("after");
        });
        var prev = button.previousElementSibling;
        if (prev) prev.classList.add("before");
        var next = button.nextElementSibling;
        if (next) next.classList.add("after");
        button.classList.add("active");
    }
    $c949cf11b3dad355$var$pagination.activePage = activeId;
    $c949cf11b3dad355$var$updateProgressBar();
    setTimeout(function() {
        return $c949cf11b3dad355$var$updateProgressBar();
    }, 400);
};
var $c949cf11b3dad355$var$getEffect = function getEffect(layout) {
    var data = {
        modules: [].concat($c949cf11b3dad355$var$baseModules),
        effect: "slide"
    };
    switch(layout){
        case "0":
            // Überblenden
            data.modules.push($bTZx8.EffectFade);
            data.effect = "fade";
            break;
        case "1":
            // Nach oben schieben
            data.modules.push($bTZx8.EffectCreative);
            data.effect = "creative";
            data.creativeEffect = {
                prev: {
                    translate: [
                        0,
                        "-100%",
                        0
                    ]
                },
                next: {
                    translate: [
                        0,
                        "100%",
                        0
                    ]
                }
            };
            break;
        case "2":
            // Nach unten schieben
            data.modules.push($bTZx8.EffectCreative);
            data.effect = "creative";
            data.creativeEffect = {
                prev: {
                    translate: [
                        0,
                        "100%",
                        0
                    ]
                },
                next: {
                    translate: [
                        0,
                        "-100%",
                        0
                    ]
                }
            };
            break;
        case "3":
            // Nach links schieben
            data.modules.push($bTZx8.EffectCreative);
            data.effect = "creative";
            data.creativeEffect = {
                prev: {
                    translate: [
                        "-100%",
                        0,
                        0
                    ]
                },
                next: {
                    translate: [
                        "100%",
                        0,
                        0
                    ]
                }
            };
            break;
        case "4":
            // Nach rechts schieben
            data.modules.push($bTZx8.EffectCreative);
            data.effect = "creative";
            data.creativeEffect = {
                prev: {
                    translate: [
                        "100%",
                        0,
                        0
                    ]
                },
                next: {
                    translate: [
                        "-100%",
                        0,
                        0
                    ]
                }
            };
            break;
        case "5":
            // Aufdecken
            data.modules.push($bTZx8.EffectCreative);
            data.effect = "creative";
            data.creativeEffect = {
                prev: {
                    translate: [
                        "100%",
                        0,
                        0
                    ]
                },
                next: {
                    shadow: true,
                    translate: [
                        0,
                        0,
                        -400
                    ]
                }
            };
            break;
        case "6":
            // Parallax
            data.modules.push($bTZx8.Parallax);
            data.speed = 600;
            data.parallax = true;
            break;
        default:
            break;
    }
    return data;
};
var $c949cf11b3dad355$var$addListenerMulti = function addListenerMulti(el, s, fn) {
    s.split(" ").forEach(function(e) {
        return el.addEventListener(e, fn, false);
    });
};
var $c949cf11b3dad355$var$changeTimeout = null;
var $c949cf11b3dad355$var$changeSlide = function changeSlide(pSlide, direction) {
    // add timeout to prevent multiple changes
    if ($c949cf11b3dad355$var$changeTimeout) clearTimeout($c949cf11b3dad355$var$changeTimeout);
    $c949cf11b3dad355$var$changeTimeout = setTimeout(function() {
        var stopTime = 800;
        var oSlider = $c949cf11b3dad355$var$sliders.oList[$c949cf11b3dad355$var$sliders.outer];
        var iSlider = $c949cf11b3dad355$var$sliders.iList[pSlide.parentElement.parentElement.id];
        if (pSlide.id === "" && iSlider.el.classList.contains("video-swiper")) {
            var parent = $c949cf11b3dad355$var$getParent(pSlide.parentElement, "ctype-ce_scrollytelling_video");
            if (iSlider.isBeginning && direction === "prev" || iSlider.isEnd && direction === "next") {
                pSlide = parent;
                iSlider = $c949cf11b3dad355$var$sliders.iList[pSlide.parentElement.parentElement.id];
            }
        }
        $c949cf11b3dad355$var$pagination.items[pSlide.id] = true;
        setTimeout(function() {
            return $c949cf11b3dad355$var$pagination.items[pSlide.id] = false;
        }, stopTime);
        setTimeout(function() {
            return $c949cf11b3dad355$var$fixTextPosition2(pSlide.id);
        }, 500);
        if (direction === "next") {
            var nextSlideId = $c949cf11b3dad355$var$pagination.list[$c949cf11b3dad355$var$pagination.list.indexOf(pSlide.id) + 1];
            if (nextSlideId && !$c949cf11b3dad355$var$pagination.items[nextSlideId]) {
                $c949cf11b3dad355$var$pagination.items[nextSlideId] = true;
                setTimeout(function() {
                    return $c949cf11b3dad355$var$pagination.items[nextSlideId] = false;
                }, stopTime);
                if ($c949cf11b3dad355$var$pagination.list.indexOf(nextSlideId) === $c949cf11b3dad355$var$pagination.list.length - 1) {
                    $c949cf11b3dad355$var$pagination.complete = true;
                    $c949cf11b3dad355$var$updateProgressBar(iSlider);
                    setTimeout(function() {
                        return $c949cf11b3dad355$var$updateProgressBar(iSlider);
                    }, 400);
                }
            }
            setTimeout(function() {
                return iSlider.slideNext();
            }, 100);
            if (iSlider.isEnd) // let nextParent = oSlider.slides[oSlider.activeIndex + 1].id;
            // pagination.progresses[nextParent] = 0;
            setTimeout(function() {
                return oSlider.slideNext();
            }, 100);
        }
        if (direction === "prev") {
            var prevSlideId = $c949cf11b3dad355$var$pagination.list[$c949cf11b3dad355$var$pagination.list.indexOf(pSlide.id) - 1];
            if (prevSlideId && !$c949cf11b3dad355$var$pagination.items[prevSlideId]) {
                $c949cf11b3dad355$var$pagination.items[prevSlideId] = true;
                setTimeout(function() {
                    return $c949cf11b3dad355$var$pagination.items[prevSlideId] = false;
                }, stopTime);
                if ($c949cf11b3dad355$var$pagination.list.indexOf(prevSlideId) < $c949cf11b3dad355$var$pagination.list.length - 1) {
                    $c949cf11b3dad355$var$pagination.complete = false;
                    $c949cf11b3dad355$var$updateProgressBar(iSlider);
                    setTimeout(function() {
                        return $c949cf11b3dad355$var$updateProgressBar(iSlider);
                    }, 400);
                }
            }
            setTimeout(function() {
                return iSlider.slidePrev();
            }, 100);
            if (iSlider.isBeginning) // let prevParent = oSlider.slides[oSlider.activeIndex - 1].id;
            // pagination.progresses[prevParent] = 1;
            setTimeout(function() {
                return oSlider.slidePrev();
            }, 100);
        }
    }, 50);
};
var $c949cf11b3dad355$var$initWheelEvent = function initWheelEvent(pSlide) {
    var lastTouchPos = null;
    var lastTouchTimeout = null;
    $c949cf11b3dad355$var$addListenerMulti(pSlide, "wheel touchmove", function(e) {
        if (e.type === "touchmove") {
            if (lastTouchTimeout) {
                clearTimeout(lastTouchTimeout);
                e.deltaY = lastTouchPos - e.touches[0].clientY;
                lastTouchPos = e.touches[0].clientY;
                if (e.deltaY > 3) e.deltaY = 3;
                if (e.deltaY < -3) e.deltaY = -3;
            } else lastTouchPos = e.touches[0].clientY;
            lastTouchTimeout = setTimeout(function() {
                return lastTouchPos = null;
            }, 100);
        }
        var iSlider = $c949cf11b3dad355$var$sliders.iList[pSlide.parentElement.parentElement.id];
        if (iSlider.animating) return;
        if ($c949cf11b3dad355$var$pagination.items[pSlide.id]) return;
        var text = pSlide.querySelector(".text");
        if (text) {
            var textPos = text.getBoundingClientRect();
            var upperBound = $c949cf11b3dad355$var$pagination.headerHeight;
            var lowerBound = window.innerHeight - $c949cf11b3dad355$var$pagination.footerHeight;
            var top = 0;
            var bottom = 0;
            var cssTop = parseInt(text.style.top.replace("%", ""));
            top = textPos.top - upperBound;
            bottom = lowerBound - textPos.bottom;
            if (top < 0 && bottom - 100 > 0 && e.deltaY > 0) $c949cf11b3dad355$var$changeSlide(pSlide, "next");
            if (bottom < 0 && top - 100 > 0 && e.deltaY < 0) $c949cf11b3dad355$var$changeSlide(pSlide, "prev");
            var delta = e.deltaY;
            if (delta > 6) delta = 6;
            if (delta < -6) delta = -6;
            cssTop = cssTop - delta;
            text.style.top = cssTop + "%";
        } else {
            if (e.deltaY > 0) $c949cf11b3dad355$var$changeSlide(pSlide, "next");
            if (e.deltaY < 0) $c949cf11b3dad355$var$changeSlide(pSlide, "prev");
        }
    });
};
// ====================================================================================
// Init
// ====================================================================================
var $c949cf11b3dad355$var$_init = module.exports.init = function init() {
    var outerEffect = $c949cf11b3dad355$var$getEffect($c949cf11b3dad355$var$outerSlider.dataset.effect);
    var outerId = $c949cf11b3dad355$var$outerSlider.id;
    $c949cf11b3dad355$var$sliders.outer = outerId;
    $c949cf11b3dad355$var$sliders.oList[outerId] = new $c949cf11b3dad355$var$_swiper["default"]("#".concat(outerId), $c949cf11b3dad355$var$_objectSpread($c949cf11b3dad355$var$_objectSpread({}, outerEffect), {}, {
        direction: "horizontal",
        a11y: true,
        keyboard: true,
        watchSlidesProgress: true,
        navigation: {
            enabled: true,
            nextEl: ".scrolly-nav-next",
            prevEl: ".scrolly-nav-prev"
        },
        on: {
            init: function init(swiper) {
                setTimeout(function() {
                    $c949cf11b3dad355$var$updateNavIndex(swiper);
                }, 500);
            },
            slideChange: function slideChange(swiper) {
                $c949cf11b3dad355$var$updateNavIndex(swiper);
            }
        }
    }));
    $c949cf11b3dad355$var$innerSliders.forEach(function(innerSlider) {
        var innerId = innerSlider.id;
        var innerEffect = $c949cf11b3dad355$var$getEffect(innerSlider.dataset.effect);
        // let parentId = innerSlider.parentElement.id;
        // pagination.progresses[parentId] = 0;
        innerSlider.querySelectorAll(".ctype-ce_scrollytelling_video").forEach(function(videoContainer) {
            var videoSlider = videoContainer.querySelector(".video-swiper");
            var thumbSlider = videoContainer.querySelector(".scrolly-thumbs");
            var thumbId = null;
            if (thumbSlider) {
                thumbId = thumbSlider.id;
                $c949cf11b3dad355$var$sliders.iList[thumbId] = new $c949cf11b3dad355$var$_swiper["default"]("#".concat(thumbId), {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    a11y: true,
                    keyboard: true,
                    watchSlidesProgress: true,
                    breakpoints: {
                        540: {
                            slidesPerView: 2,
                            spaceBetween: 32
                        },
                        768: {
                            slidesPerView: 3,
                            spaceBetween: 32
                        }
                    },
                    on: {
                        init: function init(swiper) {
                            if (swiper.slides.length > swiper.visibleSlides.length) videoContainer.classList.add("scrolly-thumbs--active");
                            else videoContainer.classList.remove("scrolly-thumbs--active");
                        },
                        resize: function resize(swiper) {
                            if (swiper.slides.length > swiper.visibleSlides.length) videoContainer.classList.add("scrolly-thumbs--active");
                            else videoContainer.classList.remove("scrolly-thumbs--active");
                        }
                    }
                });
            }
            if (videoSlider) {
                var videoId = videoSlider.id;
                var videoEffect = $c949cf11b3dad355$var$getEffect(videoSlider.dataset.effect);
                $c949cf11b3dad355$var$sliders.iList[videoId] = new $c949cf11b3dad355$var$_swiper["default"]("#".concat(videoId), $c949cf11b3dad355$var$_objectSpread($c949cf11b3dad355$var$_objectSpread({}, videoEffect), {}, {
                    a11y: true,
                    keyboard: true,
                    watchSlidesProgress: true,
                    navigation: {
                        nextEl: "#".concat(videoContainer.id, " .swiper-button-next"),
                        prevEl: "#".concat(videoContainer.id, " .swiper-button-prev")
                    },
                    thumbs: {
                        swiper: $c949cf11b3dad355$var$sliders.iList[thumbId]
                    },
                    on: {
                        init: function init(swiper) {
                            return $c949cf11b3dad355$var$_scrollytellingVideoSlide["default"].init(innerSlider, swiper);
                        },
                        slideChange: function slideChange(swiper) {
                            return $c949cf11b3dad355$var$_scrollytellingVideoSlide["default"].slideChange(swiper);
                        },
                        beforeSlideChangeStart: function beforeSlideChangeStart(swiper) {
                            return $c949cf11b3dad355$var$_scrollytellingVideoSlide["default"].beforeSlideChange(swiper);
                        }
                    }
                }));
            }
            var hideBtn = videoContainer.querySelector(".video-nav-hide");
            if (hideBtn) hideBtn.addEventListener("click", function() {
                if (videoContainer.classList.contains("video-nav-hidden")) {
                    videoContainer.classList.remove("video-nav-hidden");
                    hideBtn.querySelector(".text").innerHTML = "ausblenden";
                } else {
                    videoContainer.classList.add("video-nav-hidden");
                    hideBtn.querySelector(".text").innerHTML = "einblenden";
                }
            });
        });
        $c949cf11b3dad355$var$sliders.iList[innerId] = new $c949cf11b3dad355$var$_swiper["default"]("#".concat(innerId), $c949cf11b3dad355$var$_objectSpread($c949cf11b3dad355$var$_objectSpread({}, innerEffect), {}, {
            // direction: "vertical",
            a11y: true,
            keyboard: true,
            navigation: false,
            pagination: {
                el: "#".concat(innerId, " .swiper-pagination"),
                type: "fraction"
            },
            watchSlidesProgress: true,
            on: {
                init: function init(swiper) {
                    $c949cf11b3dad355$var$fixTextPosition(swiper);
                // updateNavIndex(swiper);
                },
                // slideChange: (swiper) => updateNavIndex(swiper),
                slideChangeTransitionStart: function slideChangeTransitionStart(swiper) {
                    return $c949cf11b3dad355$var$fixTextPosition(swiper);
                }
            }
        }));
    });
    // populate navigation
    $c949cf11b3dad355$var$pages.forEach(function(page, index) {
        var title = page.dataset.title;
        var pSlides = page.querySelectorAll(".swiper-slide");
        var button = document.createElement("button");
        button.innerHTML = title;
        button.id = "b-".concat(page.id);
        button.classList.add("nav-button");
        button.setAttribute("data-index", index);
        $c949cf11b3dad355$var$nav.appendChild(button);
        pSlides.forEach(function(pSlide, i) {
            $c949cf11b3dad355$var$pagination.items[pSlide.id] = false;
            $c949cf11b3dad355$var$pagination.list.push(pSlide.id);
            $c949cf11b3dad355$var$initWheelEvent(pSlide);
        });
        button.addEventListener("click", function() {
            var slider = $c949cf11b3dad355$var$sliders.oList[$c949cf11b3dad355$var$sliders.outer];
            slider.slideTo(index);
        });
    });
    var updateSliderHeight = function updateSliderHeight() {
        var notSliderHeight = 0;
        if ($c949cf11b3dad355$var$header) notSliderHeight += $c949cf11b3dad355$var$header.offsetHeight;
        if ($c949cf11b3dad355$var$footer) notSliderHeight += $c949cf11b3dad355$var$footer.offsetHeight;
        // if (nav) notSliderHeight += nav.offsetHeight;
        $c949cf11b3dad355$var$pagination.headerHeight = $c949cf11b3dad355$var$header.offsetHeight;
        // pagination.footerHeight = footer.offsetHeight + nav.offsetHeight;
        $c949cf11b3dad355$var$pagination.footerHeight = $c949cf11b3dad355$var$footer.offsetHeight;
        var maxSliderHeight = window.innerHeight - notSliderHeight - 5;
        $c949cf11b3dad355$var$outerSlider.style.height = maxSliderHeight + "px";
    };
    updateSliderHeight();
    setTimeout(function() {
        return updateSliderHeight();
    }, 5000);
    var attempts = 0;
    var _whenComplete = function whenComplete() {
        if (++attempts > 30) return;
        if (document.readyState === "complete") window.addEventListener("resize", function(e) {
            updateSliderHeight();
            $c949cf11b3dad355$var$updateProgressBar();
            setTimeout(function() {
                return $c949cf11b3dad355$var$updateProgressBar();
            }, 400);
        });
        else setTimeout(function() {
            return _whenComplete();
        }, 400);
    };
    _whenComplete();
};

});
parcelRegister("364bU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
function $24152ee2739a3f52$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $24152ee2739a3f52$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $24152ee2739a3f52$var$_typeof(o);
}
function $24152ee2739a3f52$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $24152ee2739a3f52$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $24152ee2739a3f52$var$_toPropertyKey(o.key), o);
    }
}
function $24152ee2739a3f52$var$_createClass(e, r, t) {
    return r && $24152ee2739a3f52$var$_defineProperties(e.prototype, r), t && $24152ee2739a3f52$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $24152ee2739a3f52$var$_defineProperty(e, r, t) {
    return (r = $24152ee2739a3f52$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $24152ee2739a3f52$var$_toPropertyKey(t) {
    var i = $24152ee2739a3f52$var$_toPrimitive(t, "string");
    return "symbol" == $24152ee2739a3f52$var$_typeof(i) ? i : i + "";
}
function $24152ee2739a3f52$var$_toPrimitive(t, r) {
    if ("object" != $24152ee2739a3f52$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $24152ee2739a3f52$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $24152ee2739a3f52$var$ScrollyTellingVideoSlide = module.exports["default"] = /*#__PURE__*/ function() {
    function ScrollyTellingVideoSlide() {
        $24152ee2739a3f52$var$_classCallCheck(this, ScrollyTellingVideoSlide);
    }
    return $24152ee2739a3f52$var$_createClass(ScrollyTellingVideoSlide, null, [
        {
            key: "init",
            value: function init(outerVideoSlide, videoSwiperComponent) {
                ScrollyTellingVideoSlide.outerVideoSlide = outerVideoSlide;
                ScrollyTellingVideoSlide.videoSwiperComponent = videoSwiperComponent;
                ScrollyTellingVideoSlide.videoCount = ScrollyTellingVideoSlide.outerVideoSlide.querySelectorAll(".video-item").length;
                ScrollyTellingVideoSlide.videoSwiperComponent.slideTo(1);
                ScrollyTellingVideoSlide.videoSwiperComponent.slideTo(0);
                ScrollyTellingVideoSlide.outerVideoSlide.querySelector(".sound-toggle").addEventListener("click", function() {
                    ScrollyTellingVideoSlide.soundEnabled = !ScrollyTellingVideoSlide.soundEnabled;
                    if (ScrollyTellingVideoSlide.soundEnabled) {
                        ScrollyTellingVideoSlide.outerVideoSlide.querySelector(".sound-toggle").classList.remove("muted");
                        ScrollyTellingVideoSlide.activeVideo.muted = false;
                    } else {
                        ScrollyTellingVideoSlide.outerVideoSlide.querySelector(".sound-toggle").classList.add("muted");
                        ScrollyTellingVideoSlide.activeVideo.muted = true;
                    }
                });
            }
        },
        {
            key: "beforeSlideChange",
            value: function beforeSlideChange(swiper) {
                // console.log('beforeSlideChange', swiper.activeIndex);
                var v = ScrollyTellingVideoSlide.videoSwiperComponent.slides[swiper.activeIndex].querySelector("video");
                v.pause();
                v.currentTime = 0;
                v.muted = true;
            }
        },
        {
            key: "slideChange",
            value: function slideChange(swiper) {
                ScrollyTellingVideoSlide.activeIndex = swiper.activeIndex;
                ScrollyTellingVideoSlide.activeThumbnail = ScrollyTellingVideoSlide.outerVideoSlide.querySelectorAll(".video-item")[ScrollyTellingVideoSlide.activeIndex];
                ScrollyTellingVideoSlide.activeThumbnailTimer = ScrollyTellingVideoSlide.activeThumbnail.querySelector(".vnav-progress");
                ScrollyTellingVideoSlide.outerVideoSlide.querySelectorAll(".video-item").forEach(function(v) {
                    return v.classList.remove("active");
                });
                ScrollyTellingVideoSlide.activeThumbnail.classList.add("active");
                ScrollyTellingVideoSlide.activeVideo = ScrollyTellingVideoSlide.videoSwiperComponent.slides[ScrollyTellingVideoSlide.activeIndex].querySelector("video");
                ScrollyTellingVideoSlide.videoSwiperComponent.wrapperEl.querySelectorAll("video").forEach(function(v) {
                //v.pause();
                //v.currentTime = 0;
                //v.muted = true;
                });
                //console.log(ScrollyTellingVideoSlide.outerVideoSlide);
                ScrollyTellingVideoSlide.activeVideo.play();
                if (ScrollyTellingVideoSlide.soundEnabled) ScrollyTellingVideoSlide.activeVideo.muted = false;
                clearInterval(ScrollyTellingVideoSlide.secondsInterval);
                ScrollyTellingVideoSlide.secondsInterval = setInterval(function() {
                    ScrollyTellingVideoSlide.activeVideoCurrentTime = ScrollyTellingVideoSlide.activeVideo.currentTime;
                    ScrollyTellingVideoSlide.activeVideoDuration = ScrollyTellingVideoSlide.activeVideo.duration;
                    var secondsRemaining = ScrollyTellingVideoSlide.activeVideoDuration - ScrollyTellingVideoSlide.activeVideoCurrentTime;
                    var percentage = ScrollyTellingVideoSlide.activeVideoCurrentTime / ScrollyTellingVideoSlide.activeVideoDuration * 100;
                    ScrollyTellingVideoSlide.activeThumbnailTimer.style.setProperty("--value", "".concat(percentage, "%"));
                    ScrollyTellingVideoSlide.activeThumbnailTimer.querySelector(".vnav-progress-timer").innerText = $24152ee2739a3f52$var$formatTime(secondsRemaining);
                    if (ScrollyTellingVideoSlide.secondsRemaining < 60) ScrollyTellingVideoSlide.activeThumbnailTimer.classList.add("seconds-only");
                    else ScrollyTellingVideoSlide.activeThumbnailTimer.classList.remove("seconds-only");
                    if (ScrollyTellingVideoSlide.activeVideoCurrentTime >= ScrollyTellingVideoSlide.activeVideoDuration) ScrollyTellingVideoSlide.videoSwiperComponent.slideNext();
                }, 100);
            }
        }
    ]);
}();
$24152ee2739a3f52$var$_defineProperty($24152ee2739a3f52$var$ScrollyTellingVideoSlide, "outerVideoSlide", null);
$24152ee2739a3f52$var$_defineProperty($24152ee2739a3f52$var$ScrollyTellingVideoSlide, "videoSwiperComponent", null);
$24152ee2739a3f52$var$_defineProperty($24152ee2739a3f52$var$ScrollyTellingVideoSlide, "videoCount", 0);
$24152ee2739a3f52$var$_defineProperty($24152ee2739a3f52$var$ScrollyTellingVideoSlide, "activeIndex", 0);
$24152ee2739a3f52$var$_defineProperty($24152ee2739a3f52$var$ScrollyTellingVideoSlide, "activeVideo", null);
$24152ee2739a3f52$var$_defineProperty($24152ee2739a3f52$var$ScrollyTellingVideoSlide, "activeThumbnail", null);
$24152ee2739a3f52$var$_defineProperty($24152ee2739a3f52$var$ScrollyTellingVideoSlide, "activeThumbnailTimer", null);
$24152ee2739a3f52$var$_defineProperty($24152ee2739a3f52$var$ScrollyTellingVideoSlide, "soundEnabled", false);
$24152ee2739a3f52$var$_defineProperty($24152ee2739a3f52$var$ScrollyTellingVideoSlide, "activeVideoDuration", null);
$24152ee2739a3f52$var$_defineProperty($24152ee2739a3f52$var$ScrollyTellingVideoSlide, "activeVideoCurrentTime", null);
$24152ee2739a3f52$var$_defineProperty($24152ee2739a3f52$var$ScrollyTellingVideoSlide, "secondsInterval", null);
function $24152ee2739a3f52$var$n0(n) {
    return n < 10 ? "0".concat(n) : n;
}
function $24152ee2739a3f52$var$formatTime(sec) {
    var minutes = Math.floor(sec / 60);
    var seconds = Math.floor(sec - minutes * 60);
    if (minutes) return "".concat($24152ee2739a3f52$var$n0(minutes), ":").concat($24152ee2739a3f52$var$n0(seconds));
    else return "".concat($24152ee2739a3f52$var$n0(seconds));
}

});


parcelRegister("7bv9Y", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $53b1bb303d082687$export$581ff339ea0ba762; });

var $cgqFP = parcelRequire("cgqFP");
function $53b1bb303d082687$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $cgqFP._define_property)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("cgqFP", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $8edbab78a07e92a4$export$1e71eb4bef00f6b0; });
function $8edbab78a07e92a4$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("evINV", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a906b7200f9116bb$export$4fa2f4023c9cbda5; });
function $a906b7200f9116bb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a906b7200f9116bb$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $a906b7200f9116bb$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});


//# sourceMappingURL=scrollytelling.module.c31c8a15.js.map
